const appInfo = {
    title: 'Mywayy Cloud'
};
export default appInfo;

